import * as yup from 'yup';

export const schema = yup.object().shape({
  accountName: yup.string()
    .required('The account name field is required.')
    .matches(/^(\w+$)/g, 'Account names should not contain spaces or special characters. Please try another option'),
});
